import React from 'react';
import { number, string } from 'prop-types';
import StoreBadgeBase from '../StoreBadgeBase';

const GooglePlay = ({ width, languageRegionCode, className }) => {
  return <StoreBadgeBase languageRegionCode={languageRegionCode} width={width} variant="google" className={className} />;
};

GooglePlay.propTypes = {
  width: number.isRequired,
  languageRegionCode: string,
  className: string
};

GooglePlay.defaultProps = {
  languageRegionCode: 'en-US',
  className: null
};

export default GooglePlay;
